import { ApplicationConfig } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAssetImages } from '@web/shared/ui';
import {
  Noir,
  provideCustomTitleStrategyConfig,
  provideHttpErrorHandlers,
  providePrimengConfiguration,
  provideRoutes,
  provideTitles,
} from '@web/common';
import { AppRoutesProviderService } from '../config/providers/app-routes-provider.service';
import { AppAssetImagesProviderService } from '../config/providers/app-asset-images-provider.service';
import { AppRouteTitlesProviderService } from '../config/providers/app-route-titles-provider.service';
import { routes } from './app.routes';
import {
  AuthTokenInterceptor,
  BadRequestHttpErrorHandler,
  CacheInterceptor,
  HttpBlobResponseErrorInterceptor,
  HttpErrorInterceptor,
  HttpLoadingInterceptor,
  RefreshTokenInterceptor,
  UnknownErrorMessageHandler,
  UnprocessableEntityErrorHandler,
  UnsupportedMediaTypeErrorHandler,
} from '@web/core';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { provideUserContext } from '@web/shared/module/auth';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideEnvironment } from '@web/config';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
    ),
    provideAnimations(),
    provideAnimationsAsync(),
    provideAssetImages(AppAssetImagesProviderService),
    provideRoutes(AppRoutesProviderService),
    provideTitles(AppRouteTitlesProviderService),
    provideClientHydration(),
    provideCustomTitleStrategyConfig(),
    provideEnvironment(environment),
    provideHttpErrorHandlers([
      BadRequestHttpErrorHandler,
      UnsupportedMediaTypeErrorHandler,
      UnprocessableEntityErrorHandler,
      UnknownErrorMessageHandler,
    ]),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        AuthTokenInterceptor,
        CacheInterceptor,
        HttpErrorInterceptor,
        HttpBlobResponseErrorInterceptor,
        HttpLoadingInterceptor,
        RefreshTokenInterceptor({ shouldSignOutAfterTokenRefreshError: false }),
      ]),
    ),
    provideUserContext(),
    providePrimengConfiguration({ preset: Noir }),
  ],
};
